import { ICampaignManagementCampaign } from '@/Interfaces/CampaignManagement/Campaign.interface';
import { ICampaignFormData } from '@/Interfaces/CampaignManagement/CampaignForm.interface';
import { getAdvertiserControlOption } from '../advertisers';

export const campaignApiDataToFormStructure = (campaign: ICampaignManagementCampaign): ICampaignFormData => {
  return {
    name: campaign.name,
    advertiser: getAdvertiserControlOption(campaign.advertiser),
    altId: campaign.alt_id ?? '',
  };
};

export const campaignFormDataToApiStructure = (formData: ICampaignFormData) => {
  return { name: formData.name, advertiserId: formData.advertiser?.value, altId: formData.altId };
};
